// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"7e9d050a","174":"ff13cf2a","281":"48190676","310":"38952a0b","335":"d5537021","345":"6dbe7324","430":"39d8e460","432":"1b940571","488":"5d03df87","606":"4df9ddaa","675":"288435a9","767":"35706430","778":"ba05f162"}[chunkId] + ".chunk.js";
};